import { render, staticRenderFns } from "./EventsOrders.vue?vue&type=template&id=e20cd7c2&"
import script from "./EventsOrders.vue?vue&type=script&lang=js&"
export * from "./EventsOrders.vue?vue&type=script&lang=js&"
import style0 from "./EventsOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports